<i18n src="./../../i18n/basket_page.json"></i18n>

<template>
    <div id="basket-page">
        <vue-headful
                :title="$t('pageTitle')"
                :description="$t('pageDescription')"
                :url="pageUrl"/>
        <div class="container-fluid">
            <navigation-bar/>

            <div v-if="getCartQuantity == null || getCartQuantity === 0">
                <div id="paralax-subpage-section" class="lazy jumbotron mt-page-nav-image" data-bg="/assets/mt-cart-header-image.jpg">
                    <div class="container">
                        <h1 class="display-1 mt-f-regular par-text-1" style="opacity: 0.5;" v-text="$t('basket')"/>
                    </div>
                </div>

                <empty-basket/>
            </div>
            <div v-else>
                <basket-content/>
            </div>
        </div>
    </div>
</template>

<script>
    import NavigationBar from "@/components/commons/NavigationBar";
    import {mapGetters} from "vuex";
    import EmptyBasket from "@/components/basket/EmptyBasket";
    import {Const} from "@/main";
    import BasketContent from "./BasketContent";

    export default {
        name: "BasketPage",
        components: {BasketContent, EmptyBasket, NavigationBar},
        data () {
            return {
                pageUrl: Const.HOST + this.$route.path
            }
        },
        computed: mapGetters([
            'getCartQuantity'
        ])
    }
</script>

<style scoped>
    #paralax-subpage-section {
        height: 200px;
    }
</style>